/**
 * @fileoverview Agent definition for prose-continuer-discovery.
 *
 * Discovery continuation agent for exploratory writing. The author is
 * discovering the story through writing — driven by character, world,
 * and narrative momentum rather than a strict plan.
 *
 * @category narrative.prose.drafting
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'prose-continuer-discovery',
  kind: 'primitive',
  name: 'Continue (Discovery)',
  description: 'Continues the story through exploratory, character-driven writing without requiring a structured chapter plan.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.prose.drafting',
    usedBy: [
      'use-content-creation-v2.ts',
      'use-ai-control-panel.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'prose-continuer-guided',
      'chapter-drafter-v2',
      'draft-refiner-v2',
    ],
  },
};
